const qualifications = [
  {
    label: 'Children and Young Peoples Workforce - NVQ/Diploma',
    name: 'children-and-young-Peoples-workforce',
    levels: [
      'L2',
      'L3',
      'L4 (Leadership and Management)',
      'L5 (Leadership and Management)',
    ],
  },
  {
    label: 'Health and Social Care  - NVQ/Diploma',
    name: 'health-and-social-care',
    levels: [
      'L2',
      'L3',
      'L4 (Leadership and Management)',
      'L5 (Leadership and Management)',
      'L5 (Assistant Practitioner)',
    ],
  },
  {
    label: 'Nursing',
    name: 'nursing',
    levels: [
      'Registered General Nurse (RGN)',
      'Registered Nurse Children (RN - Children)',
      'Registered Mental Nurse (RMN)',
    ],
  },
  {
    label: 'Food Preparation and Cooking -  NVQ/Diploma',
    name: 'food-preparation-and-cooking',
    levels: ['L1', 'L2'],
  },
  {
    label: 'Administration - NVQ/Diploma',
    name: 'administration',
    levels: ['L2'],
  },
  {
    label: 'Activities Coordination - Certificate',
    name: 'activities-coordination',
    levels: ['L1'],
  },
  {
    label: 'Cleaning and Support Services - NVQ/Diploma',
    name: 'cleaning-and-support-services',
    levels: ['L2'],
  },
];

export default qualifications;
